import { render, staticRenderFns } from "./shfx.vue?vue&type=template&id=5641499b&scoped=true"
import script from "./shfx.vue?vue&type=script&lang=js"
export * from "./shfx.vue?vue&type=script&lang=js"
import style0 from "./shfx.vue?vue&type=style&index=0&id=5641499b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5641499b",
  null
  
)

export default component.exports